import { AppContent } from 'content/AppContent';

const disclaimer: AppContent['disclaimer'] = {
  title: 'For the use of mortgage intermediaries & other professionals only.',
};

export default disclaimer;
